import React from 'react';
import activeDay from '../../images/activeDay.png';
import inActiveDay from '../../images/IplInactive.png';


const ActiveDays = (props) => {
    var { isDay, day } = props.activeDay
    return (
            <div className='text-center dayContainer' style={{background: isDay ? "none" : "none"}}>
                <div className='sun'>
                    {isDay ? <img className='activeDay' src={activeDay} alt= " "/> : <img className='activeDay' style={{opacity: 0.5}} src={inActiveDay} alt= " "/>}
                </div>
                {
                    isDay ? <span className='sunDayActive'>{day}</span> : <span className='sunDay'>{day}</span>
                }
                
            </div>
    );
}

export default ActiveDays;